var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWing2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22023 45.3413C6.90648 43.29 9.06273 39.7875 9.28023 36.5794C10.4409 19.3969 39.0721 17.16 53.6465 0C52.8909 21.8644 28.889 21.7575 14.7515 32.7169C23.8996 28.755 38.894 29.625 49.7465 22.5844C44.684 39.0375 26.624 33.6206 13.3602 38.0925C21.2577 37.3219 31.6752 41.7825 41.5227 38.2537C32.8265 51.96 21.5465 42.8044 10.6171 42.885C16.1296 44.2894 21.824 50.4319 29.4346 49.8563C20.1609 58.7812 15.3046 50.1169 8.66148 46.7944C9.33086 47.5913 9.75461 48.6075 9.80523 49.7288C9.92524 52.4344 7.82898 54.7256 5.12336 54.8475C2.41774 54.9694 0.126484 52.8713 0.00461197 50.1656C-0.0928879 47.9738 1.26461 46.0537 3.22211 45.3394L3.22023 45.3413Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWing2);
export default __webpack_public_path__ + "static/media/wing2.53da2d7bd8af2df55abaed4507748527.svg";
export { ForwardRef as ReactComponent };